<template>
    <zen-message-modal
        :isOpen="isOpen"
        @close="$emit('close')"
        title="Remove Webhook"
    >
        <template #icon>
            <zen-icon-remove />
        </template>
        <template #body>
            <div class="space-y-3">
                <p class="text-sm text-taupe-700">
                    This action <span class="font-medium">cannot</span> be
                    undone. Removing this webhook will permanently:
                </p>
                <ul
                    class="list-disc list-inside text-sm text-taupe-700 space-y-1 ml-1"
                >
                    <li>Stop all event notifications to this URL</li>
                    <li>Delete all webhook configuration and history</li>
                    <li>
                        Disable any integrations that depend on this webhook
                    </li>
                </ul>
                <p class="text-sm font-medium text-red-600">
                    Please be certain before proceeding.
                </p>
            </div>
        </template>
        <template #buttons>
            <zen-button @click="$emit('close')" variant="secondary">
                Close
            </zen-button>
            <zen-button
                @click="$emit('confirm')"
                variant="primary-danger"
                :processing="processing"
            >
                Remove
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'RemoveWebhookModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        processing: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close', 'confirm'],
}
</script>
